export const RECURRENCE = {
  SIX_HOURS: '0 */6 * * *',
  EIGHT_HOURS: '0 */8 * * *',
  TWELVE_HOURS: '0 */12 * * *',
  TWENTY_FOUR_HOURS: '0 0 * * *',
}
